export const dateFormat = (dateString: string, format = 'dd MMM yyyy') => {
    // Convert to Date object (UTC)
    let date = new Date(dateString);

    // Get time zone offset in minutes
    let offsetMinutes = date.getTimezoneOffset();

    // Adjust date by time zone offset
    date.setMinutes(date.getMinutes() - offsetMinutes);

    // Define months array
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // Format the date according to the given format
    switch (format) {
        case "dd MMM yyyy":
            return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
        case "dd/MM/yyyy":
            return padZero(date.getDate()) + "/" + padZero(date.getMonth() + 1) + "/" + String(date.getFullYear());
        case "dd/MM/yy":
            return padZero(date.getDate()) + "/" + padZero(date.getMonth() + 1) + "/" + String(date.getFullYear()).slice(-2);
        // Add more cases for additional formats as needed
        default:
            return "Invalid format";
    }
}

// Function to pad single digit numbers with leading zero
function padZero(num: any) {
    return (num < 10 ? '0' : '') + num;
}

export const subtractOneMonth = (dateStr: string) => {
    // Parse the input date string
    let [day, month, year] = dateStr.split('/').map(Number);

    // Adjust the year for two-digit format
    if (year < 100) {
        year += (year < 50) ? 2000 : 1900; // Assuming dates in 21st century or late 20th century
    }

    // Create a date object
    let date = new Date(year, month - 1, day);

    // Subtract one month
    date.setMonth(date.getMonth() - 1);

    // Adjust day if necessary (end-of-month adjustments)
    if (day !== date.getDate()) {
        date.setDate(0);
    }

    // Format the new date
    let newDay = date.getDate();
    let newMonth = date.getMonth() + 1;
    let newYear = date.getFullYear();
    
    // Return the new date string in the desired format
    return `${newDay}/${newMonth}/${newYear}`;
}